import * as types from './types';
import Api from '../lib/api';

export function currentUserAction() {
  return async (dispatch, getState) => {
      try{
          let response = await Api.get('User/Current');
          dispatch(currentUserResult( response.data.user ));
          return;
      }
      catch(err){
          console.error(err);
          return;
      }
  }
}

function currentUserResult(user) {
  return {
      type: types.USER_CURRENT,
      user
  }
}

export function updateUserProfileAction(user) {
    return async (dispatch, getState) => {
        try{
            let response = await Api.put('User', user, false);
            dispatch(currentUserResult( response.data.user ));
            return;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
  }


// WEBPACK FOOTER //
// ./src/actions/user.js